import { render, staticRenderFns } from "./OccurrenceSuspiciousScore.vue?vue&type=template&id=6762a688&"
import script from "./OccurrenceSuspiciousScore.vue?vue&type=script&lang=js&"
export * from "./OccurrenceSuspiciousScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "OccurrenceSuspiciousScore.vue"
export default component.exports